import { approveRequest } from 'accountant/worker/src/services/approvalService';
import { isUserAccountant } from 'packages/common/services/user';
import { getErrorMessageFromResponse } from 'packages/common/utils/utils';
import { DELETE_TITLE, DELETE_MESSAGE } from 'accountant/worker/src/modules/workers/constants';
import { confirmService, toasterService } from 'packages/common/ds-components';
import WorkerFormRollover from '../modals/WorkerFormRollover';
import { deleteWorker } from '../workersService';

export const CommonCrudMixin = {
  methods: {
    async onApproveMixin({ workflowTask, shouldSaveWorkerData }) {
      this.$caConfirm({
        title: 'Confirmação de aprovação',
        message: 'Deseja realmente aprovar esse funcionário?',
        confirmButtonTheme: 'primary',
        onConfirm: async () => {
          try {
            if (workflowTask) await approveRequest(workflowTask.id);
            this.$toaster.success('Aprovado com sucesso.');
            this.onApproveSuccess(shouldSaveWorkerData);
          } catch (error) {
            this.$toaster.error(getErrorMessageFromResponse(error));
          }
        },
      });
    },
    onEditMixin(workerId) {
      this.$dialogModal(WorkerFormRollover, {
        props: { workerId },
        on: {
          'on-update-list': this.updateList,
          'on-save-success': this.onSaveSuccess || Function,
        },
      }).open();
    },
    onDeletePageMixin(workerId, index) {
      confirmService.confirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        onConfirm: () => {
          deleteWorker(workerId)
            .then(() => {
              const msgSuccess = 'Funcionário excluído.';
              this.onDeleteSuccess(index);

              toasterService.success({
                title: 'Sucesso',
                content: msgSuccess,
              });

              this.updateList();
            })
            .catch(error => toasterService.error({
              title: 'Erro',
              content: getErrorMessageFromResponse(error),
            }));
        },
      });
    },
    onDeleteMixin(workerId, index) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        onConfirm: () => {
          deleteWorker(workerId)
            .then(() => {
              if (isUserAccountant()) {
                this.$toaster.success('Funcionário excluído com sucesso.');
                this.onDeleteSuccess(index);
              } else {
                this.$toaster.success('Remoção enviada para aprovação.');
                this.updateList();
              }
            })
            .catch(error => this.$toaster.error(getErrorMessageFromResponse(error)));
        },
      });
    },
  },
};
